import * as React from 'react';
import { Textarea, FormLink } from "soprasteria-ui-library";
import { IReferral } from '../../../models/IReferral';
import { FileSection } from "./FileSection"
import { REFERRAL, PATIENT } from '../../../utils/RouteConstants';
import { useParams } from 'react-router';

interface IReferralOtherInformation {
    referral?: IReferral;
    setDefaultValue?: (value?: string) => string;
    isFetchingReferral?: boolean;
    manualRegistration?: boolean;
}

export const ReferralOtherInformation: React.FunctionComponent<IReferralOtherInformation> = ({ referral, setDefaultValue, isFetchingReferral, manualRegistration }) => {
    const { patientGuidId } = useParams<{patientGuidId: string}>();

    return (
        <div className="row">
            <h5 className="col-12">Annat</h5>
            <div className="col-6">
                <Textarea rows={6} name="referralNote" label="Övriga uppgifter" maxLength={8000} defaultValue={setDefaultValue ? setDefaultValue(referral?.referralNote) : ""} inlineLabel readonly={!referral?.isEditable && !manualRegistration} />
            </div>
            {
                referral?.referenceReferralId && referral.referenceReferralNumber ?
                    <div className="col-6">
                        <FormLink name="referenceReferral" label="Orginalremiss" linkText={referral.referenceReferralNumber} to={`/${PATIENT}/${patientGuidId}/${REFERRAL}/${referral.referenceReferralId}`}  inlineLabel/>
                    </div>
                    : null
            }
            <div className="col-12">
                {
                    !isFetchingReferral && !manualRegistration ?
                        <FileSection referral={referral} />
                        : null
                }
            </div>
        </div>
    )
}